import React from 'react';
import PropTypes from 'prop-types';

import { translate } from '../commons/localize';

const Copy = ({
  of,
  items,
  replacers,
  tags
}) => {
  const text = translate(of, items, replacers);

  if (tags) {
    const content = { __html: `${text}` };
    // eslint-disable-next-line react/no-danger
    return (<div dangerouslySetInnerHTML={content} />);
  }

  return `${text}`;
};

Copy.propTypes = {
  of: PropTypes.string.isRequired,
  items: PropTypes.number,
  tags: PropTypes.bool,
  replacers: PropTypes.arrayOf(PropTypes.string)
};

Copy.defaultProps = {
  items: undefined,
  replacers: undefined,
  tags: false
};

export default Copy;
